import { styled, css } from "@pigment-css/react";
import { clsx } from "clsx";
import { ReactNode } from "react";

interface CollapsibleSectionProps {
  isExpanded: boolean;
  children: ReactNode;
}

const Wrapper = styled("div")({
  display: "grid",
  gridTemplateRows: "0fr",
  transition: "grid-template-rows 0.3s ease",
});

const expandedStyles = css({
  gridTemplateRows: "1fr",
});

const Inner = styled("div")({
  overflow: "hidden",
});

export const CollapsibleSection = ({ isExpanded, children }: CollapsibleSectionProps) => {
  return (
    <Wrapper className={clsx(isExpanded && expandedStyles)}>
      <Inner>{children}</Inner>
    </Wrapper>
  );
};
